var w = "TRACE_animation_binding", _ = [
  "translation",
  "rotation",
  "scale"
], T = /^(0|[1-9][0-9]*)$/, q = "extensions/KHR_node_visibility/visible";
function p(s) {
  return s !== null && typeof s == "object" && !Array.isArray(s) ? s : void 0;
}
function v(s) {
  return Array.isArray(s) ? s : [];
}
var $ = (s, e) => Array.isArray(s) && s.length === e && s.every((o) => typeof o == "number");
function E(s) {
  const e = s.matrix;
  if ($(e, 16)) {
    const o = Math.hypot(e[0], e[1], e[2]), m = Math.hypot(e[4], e[5], e[6]), u = Math.hypot(e[8], e[9], e[10]), r = e[0] * (e[5] * e[10] - e[6] * e[9]) - e[4] * (e[1] * e[10] - e[2] * e[9]) + e[8] * (e[1] * e[6] - e[2] * e[5]) < 0 ? -o : o, t = (n, l) => e[l * 4 + n] / [
      r,
      m,
      u
    ][l], g = t(0, 0) + t(1, 1) + t(2, 2);
    let d;
    if (g > 0) {
      const n = 0.5 / Math.sqrt(g + 1);
      d = [
        (t(2, 1) - t(1, 2)) * n,
        (t(0, 2) - t(2, 0)) * n,
        (t(1, 0) - t(0, 1)) * n,
        0.25 / n
      ];
    } else if (t(0, 0) > t(1, 1) && t(0, 0) > t(2, 2)) {
      const n = 2 * Math.sqrt(1 + t(0, 0) - t(1, 1) - t(2, 2));
      d = [
        0.25 * n,
        (t(0, 1) + t(1, 0)) / n,
        (t(0, 2) + t(2, 0)) / n,
        (t(2, 1) - t(1, 2)) / n
      ];
    } else if (t(1, 1) > t(2, 2)) {
      const n = 2 * Math.sqrt(1 + t(1, 1) - t(0, 0) - t(2, 2));
      d = [
        (t(0, 1) + t(1, 0)) / n,
        0.25 * n,
        (t(1, 2) + t(2, 1)) / n,
        (t(0, 2) - t(2, 0)) / n
      ];
    } else {
      const n = 2 * Math.sqrt(1 + t(2, 2) - t(0, 0) - t(1, 1));
      d = [
        (t(0, 2) + t(2, 0)) / n,
        (t(1, 2) + t(2, 1)) / n,
        0.25 * n,
        (t(1, 0) - t(0, 1)) / n
      ];
    }
    return {
      translation: [
        e[12],
        e[13],
        e[14]
      ],
      rotation: d,
      scale: [
        r,
        m,
        u
      ]
    };
  }
  return {
    translation: $(s.translation, 3) ? [...s.translation] : [
      0,
      0,
      0
    ],
    rotation: $(s.rotation, 4) ? [...s.rotation] : [
      0,
      0,
      0,
      1
    ],
    scale: $(s.scale, 3) ? [...s.scale] : [
      1,
      1,
      1
    ]
  };
}
function I(s) {
  const e = /* @__PURE__ */ new Map();
  for (const o of s) typeof o == "string" && o !== "" && e.set(o, (e.get(o) ?? 0) + 1);
  return s.map((o) => typeof o == "string" && e.get(o) === 1 ? o : null);
}
function K(s) {
  const e = p(s) ?? {}, o = v(p(v(e.primitives)[0])?.targets).length, m = p(p(e.extensions)?.[w]), u = m?.targetNames !== void 0 ? m.targetNames : p(e.extras)?.targetNames;
  return !Array.isArray(u) || u.length !== o ? new Array(o).fill(null) : I(u);
}
function k(s) {
  const e = p(s) ?? {}, o = v(e.nodes).map((r) => p(r) ?? {}), m = I(o.map((r) => r.name)), u = /* @__PURE__ */ new Map();
  return m.forEach((r, t) => {
    r !== null && u.set(r, t);
  }), {
    nodeByName: u,
    nodeKeys: m,
    nodeMesh: o.map((r) => Number.isInteger(r.mesh) ? r.mesh : void 0),
    morphTargetNames: v(e.meshes).map(K),
    nodeRest: o.map((r) => E(r)),
    animationKeys: I(v(e.animations).map((r) => p(r)?.name))
  };
}
function R(s, e, o) {
  const m = p(s) ?? {}, u = o !== void 0 ? e.nodeByName.get(o) : void 0, r = (t, g, d, n, l, M) => {
    const a = e.nodeMesh[d], f = a !== void 0 ? e.morphTargetNames[a] : void 0;
    if (!f || f.length === 0) {
      M.push({
        channel: t,
        reason: "invalid",
        detail: `weights on /nodes/${d}, which has no morph targets`
      });
      return;
    }
    const c = [], y = (h, i) => {
      const N = f[h];
      N == null ? c.push(h) : l.push({
        kind: "morph",
        channel: t,
        sampler: g,
        target: N,
        ...i ? { component: i } : {}
      });
    };
    n === "all" ? f.forEach((h, i) => y(i, {
      index: i,
      count: f.length
    })) : y(n), c.length && M.push({
      channel: t,
      reason: "unnamed",
      detail: `morph target(s) ${c.join(", ")} of /meshes/${a} have no name`
    });
  };
  return {
    animations: v(m.animations).map((t, g) => {
      const d = p(t) ?? {}, n = [], l = [];
      return v(d.channels).forEach((M, a) => {
        const f = p(M) ?? {}, c = p(f.target) ?? {};
        if (!Number.isInteger(f.sampler)) {
          l.push({
            channel: a,
            reason: "invalid",
            detail: "channel has no sampler"
          });
          return;
        }
        const y = f.sampler;
        let h, i;
        if (c.path !== "pointer") {
          if (!Number.isInteger(c.node) || typeof c.path != "string") {
            l.push({
              channel: a,
              reason: "invalid",
              detail: `core channel with target ${JSON.stringify(c)}`
            });
            return;
          }
          h = c.node, i = c.path;
        } else {
          const b = p(p(c.extensions)?.KHR_animation_pointer)?.pointer, A = typeof b == "string" ? b.split("/").slice(1) : [];
          if (A[0] !== "nodes" || !T.test(A[1] ?? "") || A.length < 3) {
            l.push({
              channel: a,
              reason: "unsupported",
              detail: typeof b == "string" ? b : `pointer ${JSON.stringify(b)}`
            });
            return;
          }
          h = Number(A[1]), i = A.slice(2).join("/");
        }
        const N = /^weights(?:\/(0|[1-9][0-9]*))?$/.exec(i);
        if (u !== void 0 && h === u) {
          _.includes(i) ? n.push({
            kind: "root",
            channel: a,
            sampler: y,
            path: i
          }) : l.push({
            channel: a,
            reason: "root-unsupported",
            detail: `${i} on the root "${o}"`
          });
          return;
        }
        if (N) {
          r(a, y, h, N[1] !== void 0 ? Number(N[1]) : "all", n, l);
          return;
        }
        const x = e.nodeKeys[h] ?? null;
        if (x === null) {
          l.push({
            channel: a,
            reason: "unnamed",
            detail: `/nodes/${h} has no unique name`
          });
          return;
        }
        _.includes(i) ? n.push({
          kind: "node",
          channel: a,
          sampler: y,
          node: x,
          path: i
        }) : i === q ? n.push({
          kind: "node",
          channel: a,
          sampler: y,
          node: x,
          path: "visible"
        }) : l.push({
          channel: a,
          reason: "unsupported",
          detail: `/nodes/${h}/${i}`
        });
      }), {
        index: g,
        name: e.animationKeys[g] ?? null,
        channels: n,
        dropped: l
      };
    }),
    rootMissing: o !== void 0 && u === void 0
  };
}
export {
  R as n,
  k as r,
  w as t
};

//# sourceMappingURL=names-CFkjAQeT.js.map